<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: keyof typeof variantMapping
  }>(),
  {
    variant: 'default'
  }
)

const variantMapping = {
  default: 'px-5 sm:px-6 py-4',
  mini: 'px-[30px] py-5',
  panel: 'px-padding-panel-container-horz py-3'
}

const buttonGapMapping = {
  default: 'space-x-2',
  mini: 'space-x-2',
  panel: 'gap-inline-button-to-button'
}
</script>

<template>
  <footer
    class="border-t border-t-lightest rounded-b-[15px] bg-elevated"
    :class="variantMapping[variant]"
  >
    <slot name="additional-content"></slot>
    <div class="flex justify-between items-center gap-5">
      <div class="w-full">
        <slot name="left-content"></slot>
      </div>
      <div class="flex items-center" :class="buttonGapMapping[variant]">
        <slot></slot>
      </div>
    </div>
  </footer>
</template>
